module.exports = __webpack_public_path__ + "static/p04_burroPataTop-304aaacd1ad647ff6d5a9ed959a7b0f9.png";